import { render, staticRenderFns } from "./RecipientContactModal.vue?vue&type=template&id=b9515672&"
import script from "./RecipientContactModal.vue?vue&type=script&lang=js&"
export * from "./RecipientContactModal.vue?vue&type=script&lang=js&"
import style0 from "./RecipientContactModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports